module.exports = __webpack_public_path__ + "static/media/twinkle-color-carousel-1.a57af4ea.png";